import { Component, Input, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { map, Observable } from 'rxjs';

import { DashboardTransaction, Transaction, TransactionFilter } from '@olv/ui-shared/models/merchant-transaction.model';
import { MerchantService } from '@olv/ui-shared/services/merchant.service';
import { SystemService } from '@olv/ui-shared/services/system.service';
import { TransactionDetailsComponent } from '@olv/ui-shared/ui-shared/transaction-details/transaction-details.component';
import {
  EntityTransactionHistoryComponent,
  EntityTransactionHistoryConfig,
} from '@olv/ui-shared/ui-shared/entity-transaction-history/entity-transaction-history.component';
import { EntityTransactionServiceAdapter } from '@olv/ui-shared/models/entity-transaction-service-adapter.interface';

/**
 * Service adapter implementation for dashboard transactions
 * This bridges the TransactionService to the generic EntityTransactionServiceAdapter interface
 */
class DashboardTransactionServiceAdapter implements EntityTransactionServiceAdapter<any, DashboardTransaction> {
  constructor(private systemService: SystemService) {}

  getTransactions(
    entityId: string,
    filter: TransactionFilter,
  ): Observable<{
    items: DashboardTransaction[];
    totalCount: number;
  }> {
    const backendFilter = {
      ...filter,
    };
    return this.systemService.getSystemTransactions(backendFilter).pipe(
      map((response) => ({
        items: response.items.map((tx: any) => ({
          ...tx,
          createdAt: new Date(tx.date),
          settlementDate: tx.settlementDate ? new Date(tx.settlementDate) : undefined,
          date: new Date(tx.date),
        })) as DashboardTransaction[],
        totalCount: response.totalCount,
      })),
    );
  }
}
@Component({
  selector: 'app-reports-transaction-history',
  standalone: true,
  imports: [MatIconModule, EntityTransactionHistoryComponent],
  templateUrl: './reports-transaction-history.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './reports-transaction-history.component.scss',
})
export class ReportsTransactionHistoryComponent {
  private systemService = inject(SystemService);
  private merchantService = inject(MerchantService);

  @Input() initialSearch = '';

  dashboardTransactionAdapter: EntityTransactionServiceAdapter<any, DashboardTransaction>;
  selectedTransaction: Transaction | null = null;

  searchText = ''; // Search text for the pill search component
  entityId = 'reports'; // Reports doesn't have a specific entity ID
  // Configuration for the shared transaction history component
  transactionConfig: EntityTransactionHistoryConfig<DashboardTransaction> = {
    entityType: 'dashboard',
    title: 'Transaction History',
    showDetailsPanel: true,
    filterOptions: {
      actionRequired: [],
      type: [],
      account: [],
    },
  };
  constructor() {
    this.dashboardTransactionAdapter = new DashboardTransactionServiceAdapter(this.systemService);
  }

  onTransactionSelected(transaction: Transaction): void {
    this.selectedTransaction = transaction;
    this.merchantService.openSidebar();
  }
  onTransactionUpdated(transactionId: string): void {
    // Add dashboard-specific logic here
    // For example, refresh dashboard metrics or send notifications
  }
  closeTransactionDetails(): void {
    this.selectedTransaction = null;
  }
  updateSearch(searchText: string): void {
    this.searchText = searchText;
    // Logic to handle search text update goes here
  }
}
